import withArrayValidation from "web/utils/data/validator/array/withArrayValidation";

import { ICategory } from "web/types/Category";

const getSiblingsCategoriesToShow = (
  categories: ICategory[],
  siblingsIds: number[]
) =>
  withArrayValidation(categories, (categories) =>
    categories.filter(
      (categoryItem) =>
        categoryItem &&
        siblingsIds.some((id) => `${id}` === `${categoryItem.id}`)
    )
  );

export default getSiblingsCategoriesToShow;
